// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wxfp","type":"styles_type__HqR3j","choices":"styles_choices__39NZt"};